import React, { useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../contexts/authContext";
import styled from "styled-components";

const StyledP = styled.p`
  margin-block-start: 0;
  margin-block-end: 1.5rem;
`;

const LogoutMessage = () => {
  const { currentUser } = useContext(AuthContext);

  return currentUser.isLoggedIn ? (
    <StyledP>
      Currently logged in as <strong>{currentUser.username}</strong>.<br />
      Not you? <Link to={"/logout"}>Log out</Link>.
    </StyledP>
  ) : null;
};

export default LogoutMessage;
